import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { NavController, Platform, IonInput, LoadingController } from '@ionic/angular';
import { Router } from '@angular/router';
import firebase from 'firebase/compat/app';
import { UserService } from '../services/user.service';
import { LoadingService } from '../services/loading.service';
import { ToastService } from '../services/toast.service';
import { interval } from 'rxjs';
import { Location } from '@angular/common';
@Component({
  selector: 'app-loginmobile',
  templateUrl: './loginmobile.page.html',
  styleUrls: ['./loginmobile.page.scss'],
})
export class LoginmobilePage implements OnInit {
  mobile: any;
  @ViewChild('myInput', { static: false }) myInput: IonInput;
  callingCode: any;
  codeSent: boolean = false;
  phoneNumber: any = ""
  recaptchaVerifier: any;
  verificationId: any;
  smsCode: any;
  errorMessage: any;
  length: boolean = false;
  olength: boolean = false;

  waitingResponse: boolean = false;
  checkVerifySMS: boolean = false;
  countryCode: any;
  locationObject: any = {};
  t: any;
  timeLeft: number = 59;
  interval : any;


  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '60px',
      'color': 'black',
      'font-size': '20px',
      'background-color': 'white'
    },
    containerStyles: {
      'color': 'black',
      'background-color': 'white'
    }
  };
  userId: string;
  constructor(
    public loadingController: LoadingController,
    private navController: NavController,
    private _location: Location,
    private platform: Platform,
    private authService: AuthenticationService,
    private router: Router,
    private userService: UserService,
    private loading: LoadingService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    let that = this;
    this.countryCode = '91';
    // this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
      'size': 'invisible',
      'callback': function(response) {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // onSignInSubmit();
      }
    });
    // this.loadingService.presentLoading("");
    // this.authService.getCountryData().then((data: any) => {
    //   // console.log("getCountryData ", data);
    //   this.locationObject = data;
    //   let country = this.countryCodes.filter(resp => resp.country == data.country)
    //   this.countryCode = country[0].countryCodes[0]
    // this.loadingService.dismiss();
    // setTimeout(() => {
    //   //   that.messageInput['_native'].nativeElement.focus();
    //   //   that.myInput['_native'].nativeElement.focus();
    //   that.myInput.setFocus()
    // }, 500)
    // })
  
  }
  ionviewwillenter(){
    this.codeSent = false;
  }
  continue () {

    this.userService.mobile = this.phoneNumber;
    console.log("hello ")
    this.waitingResponse = true;
    // this.loadingService.presentLoading("Sending OTP");
    if (this.platform.is('cordova')) {
      this.platformDeviceLogin()
    } else {
      this.platformBrowserLogin()
    }


  }
  platformBrowserLogin() {
    this.loading.presentLoading("");
    console.log("hello hi")
    this.authService.phoneAuth(this.countryCode + this.phoneNumber, this.recaptchaVerifier).then(resp => {
      // this.loadingService.dismiss();
      this.loading.dismiss();
      this.errorMessage = '';
      this.waitingResponse = false;
      this.codeSent = true;
      this.verificationId = resp;
      console.log("verifyPhoneNumber ", resp)
    this.timer();

      // this.callingCode = "+"+resp;
    }, error => {
      //this.loadingService.dismiss();
      this.loading.dismiss()
      this.waitingResponse = false;
      this.errorMessage = error;
      console.log("verifyPhoneNumber ", error)
    })
  }
  platformDeviceLogin() {
    this.loading.presentLoading("");
    this.authService.verifyPhoneNumber(this.countryCode + this.phoneNumber).then(resp => {
      // this.loadingService.dismiss();
      this.loading.dismiss();
      this.errorMessage = '';
      this.waitingResponse = false;
      this.codeSent = true;
      this.verificationId = resp;
      // console.log("verifyPhoneNumber ", resp)
      // this.callingCode = "+"+resp;
    this.timer();

    }, error => {
      this.loading.dismiss();
      //this.loadingService.dismiss();
      this.waitingResponse = false;
      this.errorMessage = error;
      // console.log("verifyPhoneNumber ", error)
    })
  }
  verify() {
    this.waitingResponse = true;
    if (this.platform.is('cordova'))
      this.verifyDevice()
    else
      this.verifyBrowser()
      // setTimeout(() => {
      //  this.router.navigate(['/'])
      // }, 3000);

  }
  verifyBrowser() {
    // this.toastService.presentToast("Verifying OTP...")
    //this.loadingService.presentLoading("Verifying OTP..");
    // console.log("verificationId ", this.verificationId)
    // console.log("smsCode ", this.smsCode)
    // console.log("this.locationObject ", this.locationObject)
    this.checkVerifySMS = true;
    let a=this.userService.uid;
    let data={
      uid : a
    }
    this.authService.verifyPhoneAuth(this.verificationId, this.smsCode).then((firebaseObject: any) => {
      //this.loadingService.dismiss();
      console.log("verifyPhoneAuth ", firebaseObject);
      this.userService.getUserDetails(data).subscribe((res:any)=>{
        console.log("userDetails",res);
        if(res){
          this.userId=res._id
          localStorage.setItem("userId", this.userId)
          console.log("dsfdg", this.userId)
        }
      })
      // this.authService.checkUserInit(firebaseObject.user, this.locationObject);
      this.errorMessage = "Please wait!";
    this.pauseTimer();

    }, error => {
      //this.loadingService.dismiss();
      this.waitingResponse = false;
      this.checkVerifySMS = false;
      // this.errorMessage = error.message;
      this.errorMessage = "Incorrect OTP!";
      // this.toastService.presentToast("Incorrect OTP...")
      // console.log(error.message);
   
    }

    )
    
  }
  verifyDevice() {
    // this.toastService.presentToast("Verifying OTP...")
    this.checkVerifySMS = true;
    let a=this.userService.uid;
    let data={
      uid : a
    }
    // this.loadingService.presentLoading("Verifying OTP..");
    this.authService.verifyPhoneAuth(this.verificationId, this.smsCode).then((firebaseObject: any) => {
      // this.loadingService.dismiss();
      this.userService.getUserDetails(data).subscribe((res:any)=>{
        console.log("userDetails",res);
        if(res){
          this.userId=res._id
          localStorage.setItem("userId", this.userId)
          console.log("dsfdg", this.userId)
        }
      })
      //this.authService.checkUserInit(firebaseObject.user, this.locationObject);
      this.errorMessage = "Please wait!";
    this.pauseTimer();

    }, (error:any) => {
      console.log(error.message);
      // this.loadingService.dismiss();
      this.waitingResponse = false;
      this.checkVerifySMS = false;
      // this.errorMessage = error.message;
      // this.toastService.presentToast("Incorrect OTP...")
      this.errorMessage = "Incorrect OTP!";
    })
  }
  onOtpChange(ev) {
    console.log('onOtpChange ', ev);
    this.smsCode = ev;
    if (this.smsCode.length == 6) {
      this.olength = true;
    } else {
      this.olength = false;
    }
  }
  // countryChanged(ev) {
  //   console.log(ev.detail.value);
  //   this.callingCode = "+" + ev.detail.value;
  // }
  goBack() {
   this.router.navigate(['/'])
  }

  go() {
    if (this.phoneNumber.length == 10) {
      this.length = true;
    } else {
      this.length = false;
    }

  }

  timer(){
      this.interval = setInterval(() => {
        if(this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.timeLeft = 60;
          this.pauseTimer();
        }
    console.log(this.timeLeft)

      },1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

 

}
